// React's useId() returns values like ":r2:" - colons are special CSS selector syntax
// (pseudo-classes), so they must be escaped to use the id in a CSS selector. CSS.escape()
// isn't available during SSR, so escape manually instead.
export function escapeCssIdent(value: string) {
  return value.replace(/[^\w-]/g, char => `\\${char}`)
}
